import React from 'react'
import {useDispatch} from "react-redux";
import {fetchUsers, setSelectedUserId, fetchMeetings, setSelectedMeetingId} from "../slices/usersSlice";
import {getParticipants} from "../api/client";

export const useUserCommands = () => {
    
    const dispatch = useDispatch();

    const selectedUserChanged = (userId) => {
        dispatch(setSelectedUserId(userId))
        loadMeetings();
    }

    const selectedMeetingChanged = (meetingId) => {
        dispatch(setSelectedMeetingId(meetingId))
    }

    const loadUsersInternal = (qsUserId) => {
        
        dispatch(fetchUsers()).then(a=> {
            let userId = a.payload[0].id;
            if(a.payload.find(a => a.id === qsUserId) !== undefined) {
                userId = qsUserId;
            } else if (qsUserId != null && qsUserId !== ""){
                alert("Meeting participant not found. Please refresh host/attendee list.")
            }
            dispatch(setSelectedUserId(userId))
            loadMeetings();
        });
    }

    const loadUsers = () => {

        const urlParams = new URLSearchParams(window.location.search);
        const qsUserId = urlParams.get('userId');
        const qsMeetingId = urlParams.get('meetingId');
        
        //Hack to auto fill out userId if we have a meetingId
        if(qsUserId == null && qsMeetingId != null) {
            getParticipants(qsMeetingId).then(a => {
                let host = a.find(a => a.type === "Host")
                if(host == null)
                    host = a[0];
                loadUsersInternal(host.externalUserId);
            });
        } else {
            loadUsersInternal(qsUserId);
        }
    }
    
    const loadMeetings = () => {

        const urlParams = new URLSearchParams(window.location.search);
        const qsMeetingId = urlParams.get('meetingId');

        dispatch(fetchMeetings()).then(a=> {
            if(a.payload.length > 0) {
                let meetingId = a.payload[0].id;

                if(a.payload.find(a => a.id === qsMeetingId) !== undefined) {
                    meetingId = qsMeetingId;
                }
                
                dispatch(setSelectedMeetingId(meetingId))
            }
            else {
                dispatch(setSelectedMeetingId(null))
            }
        });
    }

    return {
        loadUsers,
        loadMeetings,
        selectedUserChanged,
        selectedMeetingChanged
    };
};